import { HIDE_ALERT } from '../actionTypes';
import { alertsActions } from '../reducer';

export default () => alertsActions[HIDE_ALERT]();
